export default "__VITE_ASSET__D0aaW9N6__"